import { Component, OnInit, Input, AfterViewInit, ViewChild , ElementRef, EventEmitter, Output, HostListener} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ButtonType } from '../button/button-type';
import { ButtonPurpose } from '../button/button-purpose';
import { TooltipDirective } from '../tooltip';

@Component({
    selector: 'common-modal-component',
    templateUrl: './common.modal.component.html',
    styleUrls: ['./common.modal.component.scss'],
    standalone: false
})
export class CommonModalComponent implements OnInit, AfterViewInit {

  public showOrHide: String = '';
  public optOutModal;
  public buttonType = ButtonType;
  public _buttonPurpose = ButtonPurpose;

  @Input('size') size = '';
  @Input('header') header;
  @Output() modalOk  = new EventEmitter<String>();
  @Output() modalCancel = new EventEmitter<String>();
  @Input() disableConfirm: boolean = false;

  @ViewChild('modal') modal: ElementRef;
  @ViewChild(TooltipDirective) tooltipDirective: TooltipDirective;
  @ViewChild("modalFooter") modalFooter: ElementRef;
  @ViewChild("modalBody") modalBody: ElementRef;
  isScrollable = false;

  @Input('width') width: string;
  @Input('bodyTextColor') bodyTextColor: string;
  @Input('role') role: string = 'dialog';
  @Input() isScrollableFocus: boolean = false;

  ngOnInit() {
	this.cookieService.set( 'Delete-Modal-question-List', 'show-modal' );
  }
  ngOnChanges() {}

  constructor( private cookieService: CookieService) {

  }

  ngAfterViewInit() {
    this.checkIfScrollable();
  }

  checkIfScrollable() {
    if (this.isScrollableFocus && this.modalBody) {
      const element = this.modalBody.nativeElement;
      this.isScrollable = element.scrollHeight > element.clientHeight;
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.checkIfScrollable();
  }

  openModalDialog() {
    this.showOrHide = 'block'; // Set block css
 }

 closeModalDialog() {
  this.modalCancel.emit('Cancel Save');
 }
 closeAndSave() {
    this.modalOk.emit('Done Save');
  }

  checkTooltipPresent(): boolean {
    return this.tooltipDirective.isOpen();
  }
}
